<template>
    
    <div class="layout-wrapper layout-navbar-full layout-horizontal layout-without-menu">

        <div class="layout-container">
            <!-- Navbar -->
            <NavBar />

            <!-- Layout container -->
            <div class="layout-page">
                <!-- Content wrapper -->
                <div class="content-wrapper">
                    
                    <!-- Menu -->
                    <MenuItem />

                    <!-- Content -->
                    <div class="container-xxl flex-grow-1 container-p-y">

                        <div class="d-flex justify-content-between">
                            <h4 class="fw-bold py-3 mb-4"><span class="text-muted fw-light">NSIA ASSURANCE /</span> Tableau de bord</h4>
                            <div class="form-floating form-floating-outline mb-4">
                                <select class="form-select" id="exampleFormControlSelect1" v-model="admin"  @change="filterByUser($event)">
                                <option selected="" value="0">Tous les utilisateurs</option>
                                <option v-for="user in utilisateurs" :value="user.id">{{ user.nom }} {{ user.prenoms }}</option>
                                </select>
                                <label for="exampleFormControlSelect1">Par utilisateur</label>
                            </div>
                        </div>

                        <div class="row gy-4 mb-4">
                            <!-- CHIFFR D'AFFAIRE -->
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title align-items-center mb-1 d-flex gap-2 flex-wrap">
                                            <div class="avatar">
                                                <div class="avatar-initial bg-label-primary rounded">
                                                <i class="mdi mdi-trending-up mdi-24px"></i>
                                            </div>
                                            </div>  
                                            <div>CA <strong>T1</strong></div>
                                        </h4>
                                        <h4 class="text-primary mt-3 mb-1">
                                            {{ getMontantT1 }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title align-items-center mb-1 d-flex gap-2 flex-wrap">
                                            <div class="avatar">
                                                <div class="avatar-initial bg-label-primary rounded">
                                                <i class="mdi mdi-trending-up mdi-24px"></i>
                                            </div>
                                            </div>  
                                            <div>CA <strong>T2</strong></div>
                                        </h4>
                                        <h4 class="text-primary mt-3 mb-1">
                                            {{ getMontantT2 }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title align-items-center mb-1 d-flex gap-2 flex-wrap">
                                            <div class="avatar">
                                                <div class="avatar-initial bg-label-primary rounded">
                                                <i class="mdi mdi-trending-up mdi-24px"></i>
                                            </div>
                                            </div>  
                                            <div>CA <strong>T3</strong></div>
                                        </h4>
                                        <h4 class="text-primary mt-3 mb-1">
                                            {{ getMontantT3 }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title align-items-center mb-1 d-flex gap-2 flex-wrap">
                                            <div class="avatar">
                                                <div class="avatar-initial bg-label-primary rounded">
                                                <i class="mdi mdi-trending-up mdi-24px"></i>
                                            </div>
                                            </div>  
                                            <div>CA <strong>T4</strong></div>
                                        </h4>
                                        <h4 class="text-primary mt-3 mb-1">
                                            {{ getMontantT4 }}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Prospect <strong>enregistré</strong>
                                        </h4>
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ prospects_filter.length }}
                                        </h1>
                                    </div>
                                </div>
                            </div>

                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Secteur <strong>enregistré</strong>
                                        </h4>
                                        
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ secteurs.length }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            nature prospection <strong>enregistré</strong>
                                        </h4>
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ prospections.length }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Prospect intéressé <strong>enregistré</strong>
                                        </h4>
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ interesse }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Prospect non intéressé <strong>enregistré</strong>
                                        </h4>
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ prospects.length - interesse }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Convention <strong>enregistrées</strong>
                                        </h4>
                                        
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ convention }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Offre convention <strong>enregistré</strong>
                                        </h4>
                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ nombreBandes }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-3 col-sm-3 col-3">
                                <div class="card h-100">
                                    <div class="card-body text-nowrap">
                                        <h4 class="card-title mb-1 d-flex gap-2 flex-wrap">
                                            Utilisateur <strong>enregistrées</strong>
                                        </h4>

                                        <h1 class="text-primary mb-1 mt-4 text-center">
                                            {{ utilisateurs.length }}
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    // Import the CSS or use your own!
    import MenuItem from "@/components/MenuItem";
    import NavBar from "@/components/NavBar";
    // import { menu } from "@/assets/vendor/js/menu.js";
    // import "vue-toastification/dist/index.css";
    // import { useToast } from "vue-toastification";
    // const toast = useToast();

    export default {
        name: 'DashboardView',
        components: {
            MenuItem, NavBar
        },
        data(){
            return {
                nombreBandes: 0,
                utilisateurs : [],
                prospects : [],
                garanties : [],
                secteurs : [],
                prospections : [],
                prospects_filter : [],
                admin : 0,
                t1 : [],
                montantT1 : 0
            }
        },
        mounted(){
            
            this.getAdmins()
            this.getSecteurs()
            this.getProspections()
            this.getGaranties()
        },
        beforeMount()
        {
            this.getProspects();
            // toast.error("Une erreur s'est produite pendant l'envoie de votre message");
            // this.recupererLesBandes() ;
        },
        computed : {
            convention(){
                return this.prospects_filter.filter(el=>{
                    return el.projet_convention ==='oui'
                }).length
            },
            interesse(){
                return this.prospects_filter.filter(el=>{
                    return el.interesse === 'oui'
                }).length
            },
            getMontantT1(){
                let montant = 0
                const datas = this.prospects_filter.filter(el=>{
                    return el.date_prevision_annuelle == 'T1'
                })
                datas.forEach(element => {
                    montant += parseInt(element.prevision_annuelle)
                });
                 return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant)
            },
            getMontantT2(){
                let montant = 0
                const datas = this.prospects_filter.filter(el=>{
                    return el.date_prevision_annuelle == 'T2'
                })
                datas.forEach(element => {
                    montant += parseInt(element.prevision_annuelle)
                });
                 return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant)
            },
            getMontantT3(){
                let montant = 0
                const datas = this.prospects_filter.filter(el=>{
                    return el.date_prevision_annuelle == 'T3'
                })
                datas.forEach(element => {
                    montant += parseInt(element.prevision_annuelle)
                });
                 return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant)
            },
            getMontantT4(){
                let montant = 0
                const datas = this.prospects_filter.filter(el=>{
                    return el.date_prevision_annuelle == 'T4'
                })
                datas.forEach(element => {
                    montant += parseInt(element.prevision_annuelle)
                });
                 return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(montant)
            },
            
        },
        methods:{
            async getProspects()
            {
                
                const response = await this.$axios.get(`prospect/all?typeProfil=${this.$store.state.user.profil}&id=${this.$store.state.user.id}`)
                this.prospects = [...response.data.data]
                this.prospects_filter = [...response.data.data]
                this.loading = false
            },

            async getGaranties()
            {
                const response = await this.$axios.get('guarantees/all')
                this.garanties = [...response.data.data]
            },
            async getSecteurs()
            {
                const response = await this.$axios.get('sector/all')
                console.log(response.data);
                this.secteurs = [...response.data.data]
            },
            async getProspections()
            {
                const response = await this.$axios.get('prospection/all')
                this.prospections = [...response.data.data]
            },
            async getAdmins()
            {
                const response = await this.$axios.get('admin/all')
                this.utilisateurs = [...response.data.data]
            },
            filterByUser(e){
                if(this.admin !=0){
                    this.prospects_filter = this.prospects.filter(el=>{
                        return el.id_admin ==this.admin
                    })
                } else{
                    this.prospects_filter = [...this.prospects]
                }
            }
        }
    }
</script>

<style scoped>
.text-primary{
    color: #ce9c2b !important;
}

</style>
